<template>
  <v-app>
    <v-navigation-drawer
      v-model="drawer"
      app
    >
      <v-btn
        large block tile
        color="success"
        v-show="setup"
        @click="start()">Commencer</v-btn>
      <v-btn
        large block tile
        color="error"
        @click="stop()"
        v-show="play">Arrêter</v-btn>
      <v-card flat tile :disabled="!setup">
        <v-card-title>Tables</v-card-title>
        <v-card-text>
          <v-btn-toggle
            v-model="tables"
            multiple
          >
            <v-row>
              <v-col
                v-for="n in 12"
                :key="n"
                cols="4"
              >
                <v-btn small :value="n">{{ n }}</v-btn>
              </v-col>
            </v-row>
          </v-btn-toggle>
        </v-card-text>
      </v-card>
      <v-card flat tile :disabled="!setup">
        <v-card-title>Multiplicateurs</v-card-title>
        <v-card-text>
          <v-btn-toggle
            v-model="mults"
            multiple
          >
            <v-row>
              <v-col
                v-for="n in 12"
                :key="n"
                cols="4"
              >
                <v-btn small :value="n">{{ n }}</v-btn>
              </v-col>
            </v-row>
          </v-btn-toggle>
        </v-card-text>
      </v-card>
      <v-card flat tile :disabled="!setup">
        <v-card-title>Opérations</v-card-title>
        <v-card-text>
          <v-btn-toggle
            v-model="ops"
            multiple
          >
            <v-row dense>
              <v-col cols="12">
                <v-btn small block value="result">a x b = ?</v-btn>
              </v-col>
              <v-col cols="12">
                <v-btn small block value="mult">a x ? = c</v-btn>
              </v-col>
            </v-row>
          </v-btn-toggle>
        </v-card-text>
      </v-card>
      <v-card flat tile :disabled="!setup">
        <v-card-title>Options de jeu</v-card-title>
        <v-card-text>
          <v-checkbox
            v-model="noDoublons"
            label="Pas de doublons"
          ></v-checkbox>
          <v-text-field
            label="Nombre de tours"
            type="number"
            v-model="maxRounds"></v-text-field>
          <v-text-field
            label="Temps total partie (s)"
            type="number"
            v-model="maxTime"></v-text-field>
          <!-- v-text-field
            disabled
            label="Temps max par tour (s)"
            type="number"
            v-model="maxRoundTime"></v-text-field -->
          <v-text-field
            label="Graine aléatoire"
            append-icon="mdi-cog"
            @click:append="genSeed"
            v-model="seed"></v-text-field>
          <v-btn
            small block
            class="info"
            @click="preview"
            v-show="seed"
          >Prévisualiser</v-btn>
        </v-card-text>
      </v-card>
      <v-card flat tile :disabled="!setup">
        <v-card-title>Permaliens</v-card-title>
        <v-card-text>
          <v-row dense>
            <v-col cols="12">
              Cette page
              <a
                class="float-right"
                :href="permalink"
                target="_blank"
              >
                <v-icon>mdi-link</v-icon>
              </a>
            </v-col>
            <v-col cols="12">
              Démarrage automatique
              <a
                class="float-right"
                :href="permalinkStart"
                target="_blank"
              >
                <v-icon>mdi-link-lock</v-icon>
              </a>
            </v-col>
          </v-row>
        </v-card-text>
      </v-card>
    </v-navigation-drawer>

    <v-app-bar
      app
      color="primary"
      dark
      flat
    >
      <v-app-bar-nav-icon @click.stop="drawer = !drawer"></v-app-bar-nav-icon>
      <v-toolbar-title>Tables de multiplcation</v-toolbar-title>
      <v-spacer></v-spacer>
      <v-btn icon @click="helpDialog = true">
        <v-icon>mdi-help-circle-outline</v-icon>
      </v-btn>
    </v-app-bar>

    <v-content>
      <v-container>
        <v-row justify="center">
          <v-col lg="4" md="5" sm="6">
            <v-card flat tile class="text-right">
              <v-chip
                label large
                color="indigo lighten-4"
                class="mb-3 px-6"
              >
                Tour {{ round }}
                <span v-show="maxRounds && maxRounds > 0">&nbsp;/ {{ maxRounds }}</Span>
              </v-chip>
            </v-card>
            <v-card
              outline
              :disabled="mode !== 'play'">
              <v-card-title v-show="op === 'result'">
                <v-chip
                  label large
                  color="grey lighten-4"
                  class="ma-2 px-6">{{ table }}</v-chip>
                x
                <v-chip
                  label large
                  color="grey lighten-4"
                  class="ma-2 px-6">{{ mult }}</v-chip>
                =
                <v-chip
                  label large
                  :color="inputColor"
                  class="ma-2 px-6">
                    {{ input }}
                    <v-avatar right v-show="status">
                      <v-icon v-if="status == 'ok'">mdi-checkbox-marked-circle</v-icon>
                      <v-icon v-if="status == 'error'">mdi-alert-circle</v-icon>
                    </v-avatar>
                  </v-chip>
              </v-card-title>
              <v-card-title v-show="op === 'mult'">
                <v-chip
                  label large
                  color="grey lighten-4"
                  class="ma-2 px-6">{{ table }}</v-chip>
                x
                <v-chip
                  label large
                  :color="inputColor"
                  class="ma-2 px-6">
                    {{ input }}
                    <v-avatar right v-show="status">
                      <v-icon v-if="status == 'ok'">mdi-checkbox-marked-circle</v-icon>
                      <v-icon v-if="status == 'error'">mdi-alert-circle</v-icon>
                    </v-avatar>
                  </v-chip>
                =
                <v-chip
                  label large
                  color="grey lighten-4"
                  class="ma-2 px-6">{{ result }}</v-chip>
              </v-card-title>
              <v-card-text>
                <v-row>
                  <v-col
                    v-for="n in 9"
                    :key="n"
                    cols="4"
                  >
                    <v-btn
                      x-large depressed block
                      color="blue-grey lighten-5"
                      @click="addNumberToInput(n)"
                      :id="n">{{ n }}</v-btn>
                  </v-col>
                  <v-col cols="4">
                    <v-btn
                      x-large depressed block
                      color="error"
                      @click="clearInputAndError()"
                      id="clear">C</v-btn>
                  </v-col>
                  <v-col cols="4">
                    <v-btn
                      x-large depressed block
                      color="blue-grey lighten-5"
                      @click="addNumberToInput(0)"
                      id="0">0</v-btn>
                  </v-col>
                  <v-col cols="4">
                    <v-btn
                      x-large depressed block
                      color="primary"
                      id="ok"
                      @click="checkInput"
                      :disabled="input === '?'">OK</v-btn>
                  </v-col>
                </v-row>
              </v-card-text>
            </v-card>
            <v-card
              tile flat
              class="ma-2"
              v-show="maxTime && maxTime > 0"
            >
              <v-card-text>
                Temps de partie restant :
                {{ remainingTime }} s
                <v-progress-linear
                  :value="currentTime"></v-progress-linear>
              </v-card-text>
            </v-card>
            <v-alert
              outlined
              color="indigo"
              class="mt-3"
              v-show="error"
            >
              <div>{{ error }}</div>
            </v-alert>
          </v-col>
        </v-row>
        <v-dialog
          v-model="endDialog"
          max-width="290"
        >
          <v-card>
            <v-card-title
              class="headline indigo lighten-2"
              primary-title
            >
              <v-icon color="indigo" class="mr-2">mdi-check-bold</v-icon>
              C'est fini
            </v-card-title>
            <v-card-text class="mt-2">{{ endMsg }}</v-card-text>
            <v-card-actions>
              <v-spacer></v-spacer>
              <v-btn
                color="primary"
                text
                @click="endDialog = false"
              >
                Fermer
              </v-btn>
            </v-card-actions>
          </v-card>
        </v-dialog>
        <v-dialog
          v-model="prevDialog"
          max-width="290"
          scrollable
        >
          <v-card max-height="90%">
            <v-card-title
              class="info"
              primary-title
            >Prévisualisation</v-card-title>
            <v-card-text class="mt-2 scroll">
              <v-list dense>
                <v-list-item v-for="o in prevData" :key="o">
                  <v-chip label small color="grey lighten-4" class="mr-2">{{ o.table }}</v-chip>
                  x
                  <v-chip
                    label small
                    :color="o.op === 'mult' ? 'cyan lighten-4' : 'grey lighten-4'"
                    class="mx-2"
                  >
                    {{ o.op === 'result' ? o.mult : '?'}}
                  </v-chip>
                  =
                  <v-chip
                    label small
                    :color="o.op === 'result' ? 'cyan lighten-4' : 'grey lighten-4'"
                    class="ml-2"
                  >
                    {{ o.op === 'result' ? '?' : o.table * o.mult }}
                  </v-chip>
                </v-list-item>
              </v-list>
            </v-card-text>
            <v-card-actions>
              <v-spacer></v-spacer>
              <v-btn
                color="primary"
                text
                @click="prevDialog = false"
              >
                Fermer
              </v-btn>
            </v-card-actions>
          </v-card>
        </v-dialog>
        <v-dialog
          v-model="helpDialog"
          width="490"
          max-width="90%"
          scrollable
        >
          <v-card>
            <v-card-title
              class="info"
              primary-title
            >Introduction</v-card-title>
            <v-card-text class="mt-2">
              <p>Bienvenue dans cet outil de révision des tables de multiplication.</p>
              <p>Il vous permet de définir les tables sur lesquelles vos élèves vont
              s'entrainer, ainsi que diverses options de déroulement.</p>
              <p>Afin que vos élèves fassent tous le même exercice, utilisez une graine
              aléatoire qui reproduira la même séquence</p>
              <p>Lorsque vous utilisez une graine aléatoire, vous pouvez Prévisualiser
              la séquence qui sera présentée</p>
              <p>Partagez ensuite votre séquence au moyen l'URL du lien fourni par
              <b>Démarrage&nbsp;automatique&nbsp;<v-icon>mdi-link-lock</v-icon></b></p>
            </v-card-text>
            <v-card-actions>
              <v-spacer></v-spacer>
              <v-btn
                color="primary"
                text
                @click="helpDialog = false"
              >
                Fermer
              </v-btn>
            </v-card-actions>
          </v-card>
        </v-dialog>
      </v-container>
    </v-content>
  </v-app>
</template>

<script>
import seedrandom from 'seedrandom';

const stringRangeToList = function stringRangeToList(str) {
  const list = [];
  str.split(':').forEach((t) => {
    if (/-/.test(t)) {
      const [a, b] = t.split('-').map(x => parseInt(x, 10));
      for (let i = a; i <= b; i += 1) {
        list.push(i);
      }
    } else {
      list.push(parseInt(t, 10));
    }
  });
  return list;
};

export default {
  data: () => ({
    tables: [1, 2, 3, 4, 5, 6, 7, 8, 9, 10],
    mults: [1, 2, 3, 4, 5, 6, 7, 8, 9, 10],
    table: '?',
    mult: '?',
    input: '?',
    op: null,
    error: '',
    status: '',
    ops: ['result'],
    maxRounds: 0,
    maxTime: 0,
    startTime: null,
    currentTime: 0,
    remainingTime: '-',
    timer: null,
    maxRoundTime: 0,
    drawer: true,
    prng: null,
    seed: null,
    history: [],
    noDoublons: false,
    mode: 'setup', // setup | play
    endDialog: false,
    endMsg: '',
    timeout: 0,
    prevDialog: false,
    prevData: [],
    helpDialog: false,
  }),
  props: ['urlTables', 'urlMults', 'urlOps', 'urlSeed', 'urlStart',
    'urlRounds', 'urlTime', 'urlRoundTime', 'urlNoDoublons'],
  computed: {
    inputColor: function inputColor() {
      if (this.status === 'error') {
        return 'red lighten-3';
      }
      if (this.status === 'ok') {
        return 'green lighten-3';
      }
      return 'cyan lighten-4';
    },
    setup: function setup() {
      return this.mode === 'setup';
    },
    play: function play() {
      return this.mode === 'play';
    },
    tablesRangeString: function tablesRangeString() {
      const str = this.tables.join(':');
      return encodeURIComponent(str);
    },
    multsRangeString: function multsRangeString() {
      const str = this.mults.join(':');
      return encodeURIComponent(str);
    },
    permalink: function permalink() {
      let str = `${this.$route.path}`;
      str += `?tables=${this.tablesRangeString}`;
      str += `&mults=${this.multsRangeString}`;
      str += `&ops=${encodeURIComponent(this.ops.join(':'))}`;
      if (this.noDoublons) str += '&doublons=0';
      if (this.maxTime && this.maxTime > 0) str += `&time=${this.maxTime}`;
      if (this.maxRounds && this.maxRounds > 0) str += `&rounds=${this.maxRounds}`;
      if (this.seed) str += `&seed=${this.seed}`;
      return str;
    },
    permalinkStart: function permalink() {
      return `${this.permalink}&start=1`;
    },
    result: function result() {
      if (this.table === '?') {
        return '?';
      }
      return this.table * this.mult;
    },
    round: function round() {
      return this.history.length;
    },
    nbOps: function nbOps() {
      return this.tables.length * this.mults.length;
    },
    lastRun: function lastRun() {
      return this.maxRounds && this.round >= this.maxRounds;
    },
    allOps: function allOps() {
      return this.noDoublons && this.history.length >= this.nbOps;
    },
  },
  methods: {
    addNumberToInput: function addNumberToInput(nbr) {
      if (this.input >= 100) {
        this.setError('Pas plus de 3 chiffres au résultat');
        return;
      }
      this.clearError();
      this.input = (this.input === '?'
        ? nbr
        : this.input * 10 + nbr);
    },
    clearInputAndError: function clearInputAndError() {
      this.clearInput();
      this.clearError();
    },
    clearInput: function clearInput() {
      this.input = '?';
    },
    getOperation: function getOperation() {
      const table = this.tables[Math.floor(this.prng() * this.tables.length)];
      const mult = this.mults[Math.floor(this.prng() * this.mults.length)];
      const op = this.ops[Math.floor(this.prng() * this.ops.length)];
      return {
        table,
        mult,
        op,
      };
    },
    setOperation: function setOperation() {
      this.status = '';
      this.clearInput();
      this.clearError();
      const { table, mult, op } = this.getOperation();
      if (this.noDoublons && this.history.indexOf(`${table}x${mult}`) >= 0) {
        this.setOperation();
      } else {
        this.table = table;
        this.mult = mult;
        this.op = op;
        this.history.push(`${table}x${mult}`);
      }
    },
    checkInput: function checkInput() {
      if (
        (this.op === 'result' && this.result === this.input)
        || (this.op === 'mult' && this.mult === this.input)
      ) {
        this.status = 'ok';
        if (
          this.lastRun || this.allOps
        ) {
          setTimeout(() => {
            this.endGame();
          }, 500);
        } else {
          setTimeout(() => {
            this.setOperation();
          }, 500);
        }
      } else {
        this.status = 'error';
        this.setError(`\
Ce n'est pas la bonne réponse
Essaye encore :-)`);
        setTimeout(() => {
          this.status = '';
          this.clearInput();
        }, 700);
      }
    },
    endGame: function endGame() {
      // TODO: show summary & stats
      if (this.allOps) {
        this.endMsg = 'Tu as fait toute les tables, bravo !';
      } else if (this.timeout) {
        this.endMsg = `Tu es arrivé au bout du temps et tu as fait ${this.history.length - 1} opérations, bravo !`;
      } else {
        this.endMsg = 'La partie est finie, bravo !';
      }
      this.stop();
      this.endDialog = true;
    },
    setError: function setError(msg) {
      this.error = msg;
    },
    clearError: function clearError() {
      this.error = '';
    },
    timePlay: function timePlay() {
      const now = (new Date()).getTime();
      const elapsed = (now - this.startTime) / 1000;
      if (elapsed > this.maxTime) {
        this.timeout = 1;
        return this.endGame();
      }
      this.remainingTime = Math.ceil(this.maxTime - elapsed);
      this.currentTime = 100 * elapsed / this.maxTime;
      this.timer = setTimeout(() => {
        this.timePlay();
      }, 250);
      return this.timer;
    },
    start: function start() {
      this.prng = seedrandom(this.seed);
      if (this.maxTime) {
        this.startTime = (new Date()).getTime();
        this.currentTime = 0;
        this.timePlay();
      }
      this.mode = 'play';
      this.setOperation();
      if (!this.$vuetify.breakpoint.lgAndUp) {
        this.drawer = false;
      }
    },
    stop: function stop() {
      clearTimeout(this.timer);
      this.history = [];
      this.timeout = 0;
      this.mode = 'setup';
      this.table = '?';
      this.mult = '?';
      this.status = '';
      this.remainingTime = '-';
      this.clearInputAndError();
      this.startTime = null;
      this.currentTime = 0;
    },
    genSeed: function genSeed() {
      this.seed = Math.random().toString(36).substring(2, 10).toUpperCase();
    },
    preview: function preview() {
      this.prng = seedrandom(this.seed);
      const hist = [];
      const data = [];
      // Limit to the maximum number of rounds
      let max = this.maxRounds || 100;
      // If no doublons, limit to the max number or couples
      if (this.noDoublons) max = Math.min(max, this.nbOps);

      for (let i = 0; i < max; i += 1) {
        let cont = true;
        while (cont) {
          const op = this.getOperation();
          if (!this.noDoublons || hist.indexOf(`${op.table}x${op.mult}`) < 0) {
            data.push(op);
            hist.push(`${op.table}x${op.mult}`);
            cont = false;
          }
        }
      }
      this.prevData = data;
      this.prevDialog = true;
    },
  },
  mounted: function mounted() {
    // Keyboard events detection
    document.addEventListener('keydown', (event) => {
      if (this.mode === 'setup' || event.isComposing) return;
      const { key } = event;

      if (key === 'Delete' || key === 'Backspace') {
        this.clearInputAndError();
      }
    }, false);

    document.addEventListener('keypress', (event) => {
      if (this.mode === 'setup' || event.isComposing) return;
      const { key } = event;

      this.clearError();
      if (key === 'Enter') {
        this.checkInput();
      } else if (/^\d$/.test(key)) {
        this.addNumberToInput(parseInt(key, 10));
      }
    }, false);

    // Parameters treatment
    if (this.urlTables) {
      this.tables = stringRangeToList(this.urlTables);
    }
    if (this.urlMults) {
      this.mults = stringRangeToList(this.urlMults);
    }
    if (this.urlOps) {
      this.ops = this.urlOps.split(':');
    }
    if (this.urlSeed) {
      this.seed = this.urlSeed;
    }
    if (this.urlRounds) {
      this.maxRounds = this.urlRounds;
    }
    if (this.urlTime) {
      this.maxTime = this.urlTime;
    }
    if (this.urlRoundTime) {
      this.maxRoundTime = this.urlRoundTime;
    }
    if (this.urlNoDoublons) {
      this.noDoublons = this.urlNoDoublons;
    }
    if (this.urlStart) {
      this.$nextTick(() => {
        this.start();
      });
    }
  },
};
</script>

<style lang="stylus" scoped>
a
  text-decoration: none
</style>
